import { ProjectName } from '@previo/codebooks'
import { PrevioIdRedirect } from '@previo/core'
import router from '~/router'
import { Routes } from '~/router/routes'

const previoId = new PrevioIdRedirect(() => ({
  idAppUrl: import.meta.env.CRM_FE_PREVIO_ID_APP_URL,
  project: ProjectName.CRM,
  loginPath: router.resolve({ name: Routes.LOGIN_INDEX }).href, // includes the router base
}))

const goToPrevioIDLogin = (): void => {
  previoId.toLogin(window.location.href)
}

const goToPrevioIDLogout = (): void => {
  previoId.toLogout(window.location.href)
}

export { goToPrevioIDLogin, goToPrevioIDLogout }
